import { render, staticRenderFns } from "./DeductionsPlanDetailsInfo.vue?vue&type=template&id=c7d1ce9c&scoped=true&"
import script from "./DeductionsPlanDetailsInfo.vue?vue&type=script&lang=js&"
export * from "./DeductionsPlanDetailsInfo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c7d1ce9c",
  null
  
)

export default component.exports